// import one from '../assets/svg/projects/one.svg'
// import two from '../assets/svg/projects/two.svg'
// import three from '../assets/svg/projects/three.svg'
// import four from '../assets/svg/projects/four.svg'
// import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'

import one from '../assets/png/myReads.gif'
// import two from '../assets/png/creativeAgency2.png'
import two from '../assets/png/Agency-showcase.webp'
import three from '../assets/png/landing page.webp'
import four from '../assets/png/weather app.webp'
import five from '../assets/png/istunikturnuva.webp'
import six from '../assets/png/kou-homepage.png'
import seven from '../assets/png/united company.png'


export const projectsData = [
    {
        id: 1,
        projectName: 'MyReads: A Book Tracking App',
        projectDesc: 'A React web application that allows you to select and categorize books you have read, are currently reading, or want to read.',
        tags: ['React', 'React-Router', 'CSS'],
        code: 'https://github.com/AbdelrahmanHs86/MyReads-A-Book-Tracking-App-Hooks-version-',
        demo: 'https://myownreads.netlify.app/',
        image: one
    },
    {
        id: 2,
        projectName: 'Creative agency Template',
        projectDesc: 'Designed a template website for a creative Agency with using HTML,CSS, and multiple hover effects.',
        tags: ['HTML', 'CSS'],
        code: 'https://github.com/AbdelrahmanHs86/CreativeAgencyTemplate',
        demo: 'https://abdelrahmanhs86.github.io/CreativeAgencyTemplate/',
        image: two
    },
    {
        id: 6,
        projectName: 'University Application',
        projectDesc: 'Designed the Front-End of a website of a university registering program as a part of a 4 students assignment project',
        tags: ['HTML', 'CSS'],
        code: 'https://github.com/AbdelrahmanHs86/KOU-2.0',
        demo: 'https://abdelrahmanhs86.github.io/KOU-2.0/',
        image: six
    },
    {
        id: 3,
        projectName: 'Istunik turnuva',
        projectDesc: 'An attractive form website for a contest activity',
        tags: ['HTML', 'CSS', 'JS'],
        code: 'https://istunikturnuva.web.app/',
        demo: 'https://istunikturnuva.web.app/',
        image: five
    },
    {
        id: 4,
        projectName: 'Landing page',
        projectDesc: 'A landing page project that Builds a page of multible sections.',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/AbdelrahmanHs86/Landing-Page',
        demo: 'https://abdelrahmanhs86.github.io/Landing-Page/',
        image: three
    },
    {
        id: 5,
        projectName: 'Weather app',
        projectDesc: 'a weather app that gets the date of the day and the weather details of a specific area via US zip code and return them with your own stated feelings of the day.',
        tags: ['Ajax', 'JS6'],
        code: 'https://weather-journal-fetch-app.herokuapp.com/',
        demo: 'https://weather-journal-fetch-app.herokuapp.com/',
        image: four
    },
    {
        id: 7,
        projectName: 'United company',
        projectDesc: 'A wordpress website for an industry company in Gaziantep',
        tags: ['Wordpress', 'Elementor'],
        code: 'hhttps://razouk-co.com/en/home/',
        demo: 'https://razouk-co.com/en/home/',
        image: seven
    },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/